<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-11-23 10:57:17
 * @FilePath: 
 * @Description: 会员卡详情页面
-->
<template>
  <div class="membershipCardDetails">
    <div class="membershipCardDetailsBanner">
      <div class="cardImage">
        <img
          class="full_img"
          src="@/assets/images/voucherCenteBanner1.png"
          alt=""
        />
      </div>
      <div class="membershipCardDetailsCode" @click="memberBarCode(false)">
        <img class="full_img" src="@/assets/images/consumer_code.png" alt="" />
      </div>
      <p>请点击查看付款二维码</p>
    </div>
    <div class="mebership_card_info_con">
      <van-cell title="卡号" :value="details.CardCode" />
      <van-cell title="卡种名称" :value="details.CardTypeName" />
      <!-- <van-cell title="剩余小时数" :value="details.CardId" /> -->
      <van-cell title="余额" :value="details.allMoney" />
      <van-collapse
        v-if="details.TimesCardList && details.TimesCardList.length > 0"
        v-model="activeName1"
      >
        <van-collapse-item title="有效次卡" name="1">
          <van-cell
            :border="false"
            v-for="item in details.TimesCardList"
            :key="item.PlanId"
            :title="item.PlanName"
            :value="item.TotalTimes"
            :title-style="{ 'background-color': '#f3f5f9' }"
            value-class="discount_value_con"
          />
        </van-collapse-item>
      </van-collapse>
      <van-cell v-else title="有效次卡" :value="'无'" />
      <!-- <van-collapse
        v-if="details.Discounts && details.Discounts.length > 0"
        v-model="activeName"
      >
        <van-collapse-item title="折扣方案" name="1">
          <van-cell
            :border="false"
            v-for="item in details.Discounts"
            :key="item.VpnId"
            :title="item.VpnName"
            :value="item.DiscountName"
            :title-style="{ 'background-color': '#f3f5f9' }"
            value-class="discount_value_con"
          />
        </van-collapse-item>
      </van-collapse>
      <van-cell v-else title="折扣方案" :value="'无'" /> -->
      <van-cell title="办理时间" :value="details.StartTime" />
      <van-cell title="有效期至" :value="details.EndTime" />
      <!-- <van-cell title="支付密码" :value="details.CardId" /> -->
    </div>
    <van-goods-action v-if="showRechangeMoneyAndTimeCard==true">
      <van-goods-action-button
        color="#DCC494"
        text="充值"
        @click="handleToRecharge('recharge')"
      />
      <van-goods-action-button
        :color="$store.state.tc"
        @click="handleToRecharge('buy')"
        text="购买次卡"
      />
    </van-goods-action>
    <!--会员卡二维码弹窗 -->
    <cardCodeCom
      :show.sync="showCodeModal"
      :codeType="1"
      :memberAccountId="details.Id"
    ></cardCodeCom>
  </div>
</template>

<script>
import { handleSessionStorage } from "@/utils";
import { getWechatMemberCardDetail } from "@/api/member";
import cardCodeCom from "@/components/cardCodeCom";
export default {
  name: "MembershipCardDetails",
  props: {},
  data() {
    return {
      details: {},
      showCodeModal: false,
      MemberGuid:'',
      activeName: [],
      activeName1: [],
      showRechangeMoneyAndTimeCard:true
    };
  },
  components: { cardCodeCom },
  watch: {
    "$store.state.vpnId"(val) {
      this.vpnId = val;
      const isNeedGetCardInfo = this.$route.query.OnlyWeCardInfo;
      if (isNeedGetCardInfo) {
        this.getList();
      }
    },
  },
  created() {
      this.MemberGuid = this.$route.params.MemberGuid;
      this.details= this.$route.query;
      this.vpnId = this.$store.state.vpnId;
      if (this.vpnId) {
        this.getCardInfo();
      }
    // 判断如果OnlyWeCardInfo为true表示直接进入该页面，需要调用获取会员卡接口
    // const isNeedGetCardInfo = this.$route.query.OnlyWeCardInfo;
    // if (isNeedGetCardInfo) {
    //  if (this.vpnId) {
    //     this.getCardInfo();
    //   }
    // } else {
    //   this.details = cardInfo;
    //  this.vpnId = this.$store.state.vpnId;
    // }
  },
  mounted() {},
  methods: {
    getCardInfo() {
      getWechatMemberCardDetail({
        memberAccountId: this.MemberGuid,
        VpnId: this.vpnId,
      }).then((res) => {
        let datailData;
        res.EndTime = res.EndTime ? res.EndTime.split(" ")[0] : "";
        res.StartTime = res.StartTime ? res.StartTime.split(" ")[0] : "";
        res.allMoney = res.DonationMoney + res.LeaveMoney;
        this.showRechangeMoneyAndTimeCard = res.CardTypeInfo.IsRechargeOnline;
        datailData =res
        this.details = datailData;
      });
    },
    // handleCloseCodePop() {
    //   this.showCodeModal = false;
    //   if (this.getCodeTimer) clearTimeout(this.getCodeTimer);
    // },
    memberBarCode(isGive) {
      this.showCodeModal = true;

      // }
    },
    handleToRecharge(type) {
      this.$store.commit(
        "eleCard/setCardTypeInfo",
        type == "recharge" ? this.details : {}
      );

      this.$router.push({
        name: "CardRecharge",
        query: { cardId: this.details.CardTypeId,cardTypeCode:this.details.CardCode, fromPage: type },
      });
    },
    handleToRecordList() {
      this.$router.push({ name: "PurchaseHistory" });
    },
  },
};
</script>
<style scoped lang="scss">
.membershipCardDetails {
  line-height: 1;
  min-height: 100vh;
  background: #f3f5f9;
  padding-bottom: 100px;
  box-sizing: border-box;
  .membershipCardDetailsBanner {
    background: #fff;
    width: 100%;
    height: 418px;
    position: relative;
    text-align: center;
    box-sizing: border-box;
    margin-bottom: 20px;
    .cardImage {
      width: 100%;
      height: 260px;
      border-radius: 10px;
      overflow: hidden;
      margin: 0 auto;
    }
    .membershipCardDetailsCode {
      position: absolute;
      left: 50%;
      top: 200px;
      margin-left: -62px;
      z-index: 1;
      width: 124px;
      height: 124px;
    }

    p {
      font-size: 24px;
      color: #333;
      margin-top: 74px;
    }
  }
  .discount_value_con {
    flex: 2;
    background-color: #f3f5f9;
  }
}
</style>
